import { makeStyles, createStyles } from '@material-ui/core'

export const useDrawerUserMenuStyles = makeStyles((theme) =>
  createStyles({
    drawer: {
      '& .MuiDrawer-paper': {
        top: 64,
        boxShadow: '0px 5px 8px -3px rgba(34, 60, 80, 0.2) inset'
      },
      '& .MuiBackdrop-root': {
        top: 64
      }
    },

    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: theme.palette.grey.A400
    },

    listItemAvatar: {
      minWidth: 40
    },

    userMenuListItemText: {
      '& span, & span a': {
        fontWeight: 600,
        fontFamily: 'Montserrat',
        fontSize: 14,
        color: '#000',
        textDecoration: 'none'
      },
      '& p': {
        fontWeight: 500,
        fontSize: 11,
        fontFamily: 'Montserrat',
        color: '#757575'
      }
    },

    usernameText: {
      '& span': {
        maxWidth: 180,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      }
    },

    userMenuLinksContainer: {
      padding: '14px 0 0 23px'
    },

    userMenuLinks: {
      display: 'flex',
      flexDirection: 'column',
      padding: '14px 0 23px 0',
      borderBottom: '1px solid rgba(0, 0, 0, 0.1)'
    },

    userMenuLinksTop: {
      display: 'flex',
      alignItems: 'center',
      gap: 10
    },

    userLinksBottom: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: 8,
      gap: 10,
      '& a': {
        textDecoration: 'none',
        fontFamily: 'Montserrat',
        fontSize: 12,
        color: '#000'
      }
    },

    userLinksBottomTablet: {
      '& a': {
        fontSize: 14
      }
    },

    userMenuTitle: {
      fontFamily: 'Montserrat',
      fontWeight: 600,
      fontSize: 16,
      color: '#9E9E9E'
    },

    userLinksTitle: {
      fontFamily: 'Montserrat',
      fontWeight: 600,
      fontSize: 14
    },

    userLinksTitleTablet: {
      fontSize: 15
    },

    tabletMenuList: {
      padding: '50px 20px 85px 0',
      [theme.breakpoints.down('xs')]: {
        padding: '15px 20px 85px 0'
      }
    }
  })
)
